var React = require('react');

function HamburgerIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.7443 29.9999H46.257M13.7443 40.0042H46.257M13.7433 19.996H46.256","stroke":"currentColor","strokeWidth":"3.5625","strokeLinecap":"square","strokeLinejoin":"round"}));
}

HamburgerIcon.defaultProps = {"fill":"none","viewBox":"10 10 40 40"};

module.exports = HamburgerIcon;

HamburgerIcon.default = HamburgerIcon;
